import { Firestore as db } from "./firebase";
import { collection, getDocs, getDoc, query, doc } from "firebase/firestore";

export const getShelters = async () => {
  const shelters = [];
  const sheltersColRef = collection(db, "shelters");
  const q = query(sheltersColRef);
  try {
    const snapshot = await getDocs(q);
    snapshot.forEach((doc) => {
      let shelter = doc.data();
      shelter.id = doc.id;
      shelters.push(shelter);
    });
    return shelters;
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getShelterById = async (id) => {
  if (!id) return;
  const docRef = doc(db, "shelters", id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    console.error("No such document!");
    return undefined;
  }
};

export const getJobOffers = async () => {
  const jobOffers = [];
  const jobOffersColRef = collection(db, "jobOffers");
  const q = query(jobOffersColRef);
  try {
    const snapshot = await getDocs(q);
    snapshot.forEach((doc) => {
      let jobOffer = doc.data();
      jobOffer.id = doc.id;
      jobOffers.push(jobOffer);
    });
    return jobOffers;
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getJobOfferById = async (id) => {
  if (!id) return;
  const docRef = doc(db, "jobOffers", id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    console.error("No such document!");
    return undefined;
  }
};

export const getMaterialHelpList = async () => {
  const list = [];
  const ref = collection(db, "materialHelp");
  const q = query(ref);
  try {
    const snapshot = await getDocs(q);
    snapshot.forEach((doc) => {
      let materialHelp = doc.data();
      materialHelp.id = doc.id;
      list.push(materialHelp);
    });
    return list;
  } catch (err) {
    console.error(err);
    return [];
  }
};